import {Fancybox} from '@fancyapps/ui/dist/fancybox.esm.js';

const FormPopup = () => {

    const formLinks = document.querySelectorAll('[data-form-popup]');

    Array.from(formLinks).forEach(formLink => {

        let formID = formLink.getAttribute('data-form-popup');
        let formHtml = document.querySelector(`#${formID}`);

        formLink.addEventListener('click', (e) => {
            e.preventDefault();
            const fancybox = new Fancybox([{
                dragToClose: false,
                mainClass: 'fancybox-form',
                preload: false,
                src: formHtml,
                type: 'html',
            }]);
        });

    });

}

export default FormPopup;